export function getView(width: number) {
    if (width < 601) {
        return 'timeGridDay';
    } else {
        return 'timeGridWeek';
    }
}
export function getViewTimeLine(width: number) {
    if (width < 601) {
        return 'resourceTimelineDay';
    } else {
        return 'resourceTimelineWeek';
    }
}
